import React from 'react'
import { AsyncState, Widget } from 'widgets-for-react'
import { any, async, fromJSX, Updater } from 'widgets-for-react'
import { getCookie } from '../../../../utils/cookies'
import { ComponentDidMount } from '../../../../utils/lifecycleMethods'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, HomePage, Page } from '../../cmsPageState'
import { HomePageHeader } from './homePageLayout'

export const homePageWidget =
  (acceptVideoCookie: () => void) =>
  (page: HomePage): Widget<Updater<Page>> =>
    any([
      // async<string>(page.vimeoSrc).map(cmsPageStateUpdaters.homePagestateUpader),
      fromJSX(() => (
        // -----Note: Commented out homepage header video
        // <ComponentDidMount
        //   onMount={() => {
        //     if (getCookie('video-cookies') === 'yes') {
        //       const script = document.createElement('script')
        //       script.src = 'https://player.vimeo.com/api/player.js'
        //       script.defer = true
        //       document.body.appendChild(script)
        //     }
        //   }}
        // >
          <HomePageHeader title={page.title} intro={page.intro}/>
        // </ComponentDidMount>
      )),
      blocksWidget(acceptVideoCookie)(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
